import i18n from 'i18n-js';

import en from './translations/en.json';
import nb from './translations/nb.json';
import sv from './translations/sv.json';
import fi from './translations/fi.json';

import connectorErrorsEn from './translations/connector-errors/en.json';
import connectorErrorsNb from './translations/connector-errors/nb.json';
import connectorErrorsSv from './translations/connector-errors/sv.json';
import connectorErrorsFi from './translations/connector-errors/fi.json';
import * as dateFnsLocale from 'date-fns/locale';

const updateLocale = (language: string) => {
    const languageCode = language.split('-')[0];
    if (!i18n.translations[languageCode]) {
        return;
    }
    i18n.locale = languageCode;
};

export function getDateFnsLocale(locale: string) {
    switch (locale) {
        case 'sv':
            return dateFnsLocale.sv;
        case 'en':
            return dateFnsLocale.enGB;
        case 'fi':
            return dateFnsLocale.fi;
        case 'nb':
        case 'nn':
        case 'no':
            return dateFnsLocale.nb;
        default:
            throw new Error(`Unsupported locale: ${locale}`);
    }
}

i18n.defaultLocale = 'en';
i18n.fallbacks = true;
i18n.translations = {
    en: { ...en, ConnectorErrors: connectorErrorsEn },
    nb: { ...nb, ConnectorErrors: connectorErrorsNb },
    nn: { ...nb, ConnectorErrors: connectorErrorsNb },
    no: { ...nb, ConnectorErrors: connectorErrorsNb },
    sv: { ...sv, ConnectorErrors: connectorErrorsSv },
    fi: { ...fi, ConnectorErrors: connectorErrorsFi },
};
export { updateLocale };

export default i18n;

export type TranslationKeys = NestedKeys<typeof en & { ConnectorErrors: typeof connectorErrorsEn }>;

type DotPrefix<T extends string, U extends string> = '' extends U ? T : `${T}.${U}`;

type NestedKeys<T> = {
    [K in keyof T & string]: T[K] extends object ? DotPrefix<K, NestedKeys<T[K]>> : K;
}[keyof T & string];
